package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FixProduct(
    @SerialName("amount")
    val amount: Int?,
    @SerialName("code")
    val code: String?,
    @SerialName("price")
    val price: Double?,
    @SerialName("__typename")
    val typename: String?
)